var _defs, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00214e;}.cls-2{fill:#f2a196;}.cls-3{fill:#e88870;}.cls-4{fill:none;stroke:#00214e;stroke-miterlimit:10;}.cls-5{fill:#f2d4cf;}.cls-6{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 109.87,
    y1: 140.89,
    x2: 166.58,
    y2: 65.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00214e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6878b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#00214e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.38,149.67c-.41-33.19-6.33-69.59-36.31-89.15C195,42.86,158.32,43.72,131.45,61a77.55,77.55,0,0,0-10.22,7.8,105.09,105.09,0,0,0-26.66,39,130.84,130.84,0,0,0-9,54.2c1.67,37.14-2.36,74.39-2.36,111.68,0,1.29,0,2.77,1,3.59a4.27,4.27,0,0,0,3,.59c15.62-.87,29.45-3.57,44.53-6.08,18.8-3.12,39.07-2.23,58.1-3.42,11.33-.66,23.24-2.49,34.57-2,3.61.16,35.22,4.85,35.36,6.8C256.75,231.8,258.89,191,258.38,149.67ZM148,145.49l-14.09-10a130.31,130.31,0,0,0,31.94-16,70.63,70.63,0,0,0,21.84-23l5.71,3.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.41,280.37a184.56,184.56,0,0,1-226.48-1l48.66-22.81a47.68,47.68,0,0,0,4.35-2.34l1.12-.7c.4-.25.79-.51,1.18-.78a46.54,46.54,0,0,0,14.67-16.47c4-7.55,5.32-15.89,5.38-24.39,0-4.67-.19-9.34-.31-14q0-1.57-.06-3.15-.06-4.75-.1-9.51l.07,0,1.91,1,5.2,2.69,30.29,5.15,31.12,5.3.71,24,.2,6.88,0,1.07.47,15.87,11.47,4.67,9,3.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.12,223.37a12.12,12.12,0,0,1-7.34,2.11C192,223.89,163.14,212.3,145,190.85q0-1.57-.06-3.15l0-2.47,1.91,1,5.2,2.69,30.29,5.15,31.12,5.3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.82,
    cy: 153.19,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 125.82,
    cy: 151.19,
    r: 17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.36,127.45c11.74,40.68-13.2,89.87-28.54,89.87-21,0-72-16.78-83.73-57.46S127,78.94,158,70,223.62,86.76,235.36,127.45Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.31,176.87a29.74,29.74,0,0,0,18.54,9.69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.93,131.73c-.05.2,4.79,8.56,7.31,17.59a58,58,0,0,1,1.62,14.76H193.35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.34,123.22a31.18,31.18,0,0,1,22.85-2.16"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.19,127.2a36.75,36.75,0,0,1,31.23-1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.73,136.06c6.1.05,6.1,9.38,0,9.42h-.27c-6.1,0-6.1-9.37,0-9.42h.27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.86,134.67c5.66,0,5.66,8.7,0,8.74h-.25c-5.67,0-5.67-8.7,0-8.74h.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.93,59.32a113.91,113.91,0,0,1-2.27,14,81,81,0,0,1-9,23.18,70.63,70.63,0,0,1-21.84,23,130.31,130.31,0,0,1-31.94,16,202.94,202.94,0,0,1-27.46,7.23c.31-7.63,0-17.07.94-25.93.7-6.36,2.1-12.43,4.92-17.32a79.54,79.54,0,0,1,32.19-30.3l.12-.06C159.38,61.51,182.29,54,198.93,59.32Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.41,280.37a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09,44.69,44.69,0,0,0,4.64-14.48,28.66,28.66,0,0,0,2.22,1.94A95.14,95.14,0,0,0,166.59,235a99,99,0,0,0,10.46,3.69,93.52,93.52,0,0,0,33,3.49c1.54-.12,3.09-.27,4.63-.38l.15,5.08v.33l12.1,4.92Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M187.64,96.54a70.63,70.63,0,0,1-21.84,23,130.31,130.31,0,0,1-31.94,16l-26.52-18.7-12.77-9a105.09,105.09,0,0,1,26.66-39A77.55,77.55,0,0,1,131.45,61l13,8.22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSvgrepoCom);
export default __webpack_public_path__ + "static/media/avatar-svgrepo-com.0f86570c951a36a4b4eb188b12c4b010.svg";
export { ForwardRef as ReactComponent };